import React from 'react';
import { Grid } from 'ui-toolkit/components/Grid';
import { BodyText, BoldBodyText, Header3Text } from 'ui-toolkit/components/Typography/basicTypography';

export const SuccessMessage = (
  <Grid textAlign={'center'}>
    <Header3Text>Property Address has been updated!</Header3Text>
    <div>
      <BodyText>Documents have regenerated.</BodyText>
      <BoldBodyText>Note: A new title search may be required.</BoldBodyText>
    </div>
  </Grid>
);
